import cn from "@/utils/cn"

type BadgeVariant = "success" | "danger" | "warning" | "info"

type BadgeProps = {
  label: string
  icon?: string
  variant: BadgeVariant
}

const Badge = ({ label, icon, variant }: BadgeProps) => {
  const variantStyles: Record<BadgeVariant, string> = {
    success: "bg-green-100 text-green-700",
    danger: "bg-red-100 text-red-700",
    warning: "bg-yellow-100 text-yellow-700",
    info: "bg-blue-100 text-blue-700",
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-3 py-1 text-sm font-medium",
        variantStyles[variant]
      )}
    >
      {icon && <span className="material-icons text-icon-sm">{icon}</span>}
      <span>{label}</span>
    </span>
  )
}

export default Badge
